import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Button from '@material-ui/core/Button'
import { makeStyles } from '@material-ui/core/styles'
import { useFeatureFlags, flags } from 'lib/feature-flags'
import CurrencyField from 'components/form-util/currency'
import AccountRouterLink from 'components/account-router-link'
import blue from '@material-ui/core/colors/blue'
const useStyles = makeStyles(theme => ({
  currencyStyled: {
    width: '450px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
}))

const Fees = ({ paymentAccounts }) => {
  const { errors, register, control } = useFormContext()
  const classes = useStyles()

  const [isStripeFlatFeeDeducted] = useFeatureFlags([
    flags.FLAT_FEAT_STRIPE_FEE_DEDUCTED,
  ])

  return (
    <>
      <Box mb={1.5}>
        <Typography variant="subtitle1">Price</Typography>
      </Box>
      <Box mb={2}>
        <div className={classes.currencyStyled}>
          <CurrencyField
            name="price"
            label="Price per person"
            inputRef={register}
            error={!!errors.price}
            helperText={errors?.price?.message}
          />
        </div>
      </Box>
      {isStripeFlatFeeDeducted && (
        <Box
          p={1}
          mb={5}
          borderRadius={4}
          style={{ backgroundColor: blue[50] }}
        >
          <Typography variant="body2">
            Please note that we use Stripe to process credit card transactions
            and that it charges a fee of 2.9% + $0.30 applied to the transaction
            total.
          </Typography>
        </Box>
      )}
      <Box mb={2}>
        <Typography variant="subtitle1" gutterBottom>
          Payment account
        </Typography>
        <Typography variant="body2" gutterBottom>
          Select a payment account to collect registration fees online for this
          event. If no payment account is selected, upfront payments will not be
          required.
        </Typography>
      </Box>
      <FormControl
        error={!!errors.paymentAccountId}
        variant="outlined"
        style={{ maxWidth: '450px' }}
      >
        <InputLabel id="category">Select payment account</InputLabel>
        <Controller
          defaultValue=""
          as={
            <Select
              labelId="paymentAccount"
              label="Select paymentAccount"
              value=""
              defaultValue=""
            >
              {paymentAccounts.map(opt => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.name} – x{opt.last4}
                </MenuItem>
              ))}
              <MenuItem key="none" value="">
                <em>None</em>
              </MenuItem>
            </Select>
          }
          name="paymentAccountId"
          control={control}
        />
      </FormControl>
      <Button
        color="primary"
        size="small"
        to="/account/payments/payment-accounts"
        component={AccountRouterLink}
      >
        Manage Payment Accounts
      </Button>
    </>
  )
}

export default Fees
